export enum userRegisterActiontype {
  REGISTER_USER = "register_user",
  REGISTER_USER_SUCCESS = "register_user_success",
  REGISTER_USER_FAILURE = "register_user_failure",
}
